module.exports = __webpack_public_path__ + "static/media/mmmatch.79bb6767.png";